// src/utils/themes.js

export const lightTheme = {
    colors: {
        background: "#FFFFFF",
        text: "#222222",
        primary: "#007AFF",
        secondary: "#5856D6",
        contentPrimary: "#222222",
        contentSecondary: "#6F6F6F",
        contentInverse: "#FFFFFF",
        fillPrimary: "#FFFFFF",
        fillSecondary: "#EBEBEB",
        fillTertiary: "#F4F4F4",
        negativeFillPrimary: "#E10000",
        negativeFillSecondary: "#FCE5E5",
        positiveFillPrimary: "#0A8200",
        positiveFillSecondary: "#E6F2E5",
        opinionContent: "#865A1C",
        opinionFillPrimary: "#E7DED2",
        opinionFillSecondary: "#F5F0EB"
    }
};
  
export const darkTheme = {
    colors: {
        background: "#222222",
        text: "#FFFFFF",
        primary: "#007AFF",
        secondary: "#5856D6",
        contentPrimary: "#FFFFFF",
        contentSecondary: "#CCCCCC",
        contentInverse: "#222222",
        fillPrimary: "#222222",
        fillSecondary: "#333333",
        negativeFillPrimary: "#F35F5A",
        negativeFillSecondary: "#410000",
        positiveFillPrimary: "#35A62D",
        opinionContent: "#CFBDA4",
        opinionFillPrimary: "#534736",
        opinionFillSecondary: "#39342D"
    }
};